/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "@/components/ui/button";
import { DialogFooter } from "@/components/ui/dialog";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { IconRender } from "@/components/shared/Icon-render";
import { PasswordInput } from "@/components/form-input";
import { usePasswordResetForm } from "../react-hook/use-password-reset-form";
import { ArrowLeft } from "lucide-react";
import { RequiredInput } from "@/components/shared/required-input";

type UserFormType = {
  formData: any;
  onOpenChange: (prop: any) => void;
  onFormSubmit: (prop: boolean) => Promise<void>;
  open: boolean;
  isFormReset: boolean;
  setIsFormReset: (prop: boolean) => void;
};
export const PasswordResetForm = ({
  formData,
  onOpenChange,
  onFormSubmit,
  open,
  isFormReset,
  setIsFormReset,
}: UserFormType) => {
  const { form, onSubmit } = usePasswordResetForm({
    formData,
    onOpenChange,
    onFormSubmit,
    open,
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="flex gap-x-6 gap-y-5 px-6 justify-between">
          <FormField
            control={form.control}
            name="password"
            render={({ field }) => (
              <FormItem className=" grow">
                <FormLabel>
                  New Password
                  <RequiredInput />
                </FormLabel>
                <FormControl>
                  <PasswordInput placeholder="New Password" field={field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <div className="pt-8">
            <Button
              variant={"outline"}
              className="bg-slate-900 text-white"
              onClick={() => setIsFormReset(!isFormReset)}
              type="button"
            >
              <ArrowLeft /> Update Email Listener
            </Button>
          </div>
        </div>
        <hr className="mt-5" />
        <DialogFooter className="p-6 flex !justify-start">
          <Button
            type="submit"
            className="w-[120px]"
            disabled={form.formState.isSubmitting}
          >
            {form.formState.isSubmitting ? (
              <IconRender
                name="LoaderCircle"
                className="w-5 animate-spin text-white zoom-in-150"
              />
            ) : (
              "Reset Password"
            )}
          </Button>
          <Button
            type="submit"
            onClick={() => onOpenChange(false)}
            variant={"outline"}
            className="w-[120px]"
          >
            Close
          </Button>
        </DialogFooter>
      </form>
    </Form>
  );
};
